export default __webpack_public_path__ + "static/Heap-24fbb03acb17bb69c63d2311866f4b1f.png";